export default {
  setOrdersOpened: (state, ordersOpened) => {
    state.ordersOpened = ordersOpened;
  }
};
